import { DndContext, DragEndEvent } from '@dnd-kit/core';
import { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import { useRecoilState } from 'recoil';
import { replanningDvhComparisonOpenState } from '~/state/atoms/adaptiveReplanningAtoms';
import DvhComparisonContent, {
    DVH_COMPARISON_PANEL_WIDTH,
    DvhPanelPosition,
} from './DvhComparisonContent';

function defaultPosition(): DvhPanelPosition {
    return {
        x: Math.max(16, window.innerWidth - DVH_COMPARISON_PANEL_WIDTH - 24),
        y: 88,
    };
}

export default function DvhComparisonPanel() {
    const [open, setOpen] = useRecoilState(replanningDvhComparisonOpenState);
    const [position, setPosition] = useState<DvhPanelPosition>(defaultPosition);

    const handleDragEnd = useCallback((event: DragEndEvent) => {
        setPosition((prev) => ({
            x: prev.x + event.delta.x,
            y: prev.y + event.delta.y,
        }));
    }, []);
    const close = useCallback(() => setOpen(false), [setOpen]);

    if (!open) {
        return null;
    }
    return createPortal(
        <DndContext onDragEnd={handleDragEnd}>
            <DvhComparisonContent position={position} onClose={close} />
        </DndContext>,
        document.body
    );
}
